import { render } from "./productListView.vue?vue&type=template&id=670bd642&scoped=true"
import script from "./productListView.vue?vue&type=script&lang=js"
export * from "./productListView.vue?vue&type=script&lang=js"

import "./productListView.vue?vue&type=style&index=0&id=670bd642&scoped=true&lang=css"

import exportComponent from "/Users/baojian/Documents/anyway/anyway-wx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-670bd642"]])

export default __exports__